import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';


export class IStaff extends BaseEntity {
    name: string;
    email: string;
    phoneNumber: string;
}

export class StaffService extends BaseService<IStaff> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'hr/staffmember');
    }

    public getUser = (id) => {
        return this.customGet( id + '/user').then((item: any) => {
            return item;
        });
    }

    public createUser = (id, user) => {
        return this.customPost( id + '/user', user).then((item: any) => {
            return item;
        });
    }

    public deleteUser = (id) => {
        return this.customDelete( id + '/user').then((item: any) => {
            return item;
        });
    }

    public getRoles = (id) => {
        return this.customGet( id + '/roles').then((item: any) => {
            return item;
        });
    }

    public putRoles = (id, roles) => {
        return this.customPut( id + '/roles', {roles: roles}).then((item: any) => {
            return item;
        });
    }

    public putPassword = (id, password) => {
        return this.customPut( id + '/password', {password: password}).then((item: any) => {
            return item;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/staff.service.ts